import React from 'react';
import { motion } from 'framer-motion';
const scienceCards = [{
  icon: '🐌',
  title: 'Tu metabolismo se enlentece',
  text: 'Después de los 40, tu cuerpo quema menos calorías en reposo. Lo que antes funcionaba, ahora no.'
}, {
  icon: '⚖️',
  title: 'Tus hormonas fluctúan',
  text: 'Los cambios en estrógeno y progesterona afectan cómo almacenas grasa y cómo te sientes.'
}, {
  icon: '🔥',
  title: 'La inflamación aumenta',
  text: 'El estrés crónico, la falta de sueño y ciertos alimentos causan inflamación silenciosa.'
}];
export function ScienceSection() {
  return <section className="bg-white py-16 md:py-24 px-4" data-id="element-211">
      <div className="max-w-6xl mx-auto" data-id="element-212">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-213">
          <span className="text-warm-accent font-bold tracking-widest text-sm uppercase mb-4 block" data-id="element-214">
            La verdad que nadie te dice
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-olive" data-id="element-215">
            ¿Por qué tu cuerpo cambia después de los 40?
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16" data-id="element-216">
          {scienceCards.map((card, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.15
        }} className="bg-cream p-8 rounded-2xl text-center border border-sage/10 hover:border-sage/30 transition-colors" data-id="element-217">
              <div className="text-5xl mb-6" data-id="element-218">{card.icon}</div>
              <h3 className="text-xl font-bold text-olive mb-4 font-heading" data-id="element-219">
                {card.title}
              </h3>
              <p className="text-warm-gray leading-relaxed" data-id="element-220">{card.text}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-sage text-white p-8 md:p-10 rounded-2xl text-center max-w-4xl mx-auto shadow-lg" data-id="element-221">
          <p className="text-lg md:text-xl font-medium leading-relaxed" data-id="element-222">
            <span className="font-bold block mb-2 text-xl md:text-2xl" data-id="element-223">
              La buena noticia:
            </span>
            Una vez que entiendes estos cambios, puedes trabajar CON tu cuerpo,
            no contra él. Y eso es exactamente lo que te enseña esta guía.
          </p>
        </motion.div>
      </div>
    </section>;
}